import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import Modal from "react-modal"
import { Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"

const ItineraryListing = ({ module }) => {
  const itineraryData = useStaticQuery(graphql`
    query itineraryQuery {
      allWpItinerary(sort: { id: ASC }) {
        nodes {
          excerpt
          title
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          itineraryContent {
            nights
            price
            sliderGallery {
              image {
                mediaItemUrl
                altText
              }
            }
            destinations {
              destinationName
            }
            description
            tabs {
              tabTitle
              tabContent
            }
            button {
              url
              title
              target
            }
            watchVideo {
              url
              title
              target
            }
            downloadPdf {
              url
              title
              target
            }
          }
        }
      }
    }
  `)
  const allItineraries = itineraryData.allWpItinerary

  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }

  const [modalIsOpenMap, setIsOpenMap] = React.useState(false)
  const [modalData, setModalData] = React.useState(null)

  const res =
    modalData !== null
      ? modalData?.itineraryContent?.tabs
        ? modalData?.itineraryContent?.tabs[0].tabTitle.replace(/ /g, "")
        : null
      : null
  const [tabOption, setTabOption] = useState(res)

  useEffect(() => {
    setTabOption(res)
  }, [modalData])

  function openModalMap(data) {
    document.body.classList.add("modal-open")
    setIsOpenMap(true)
  }
  function closeModalMap() {
    document.body.classList.remove("modal-open")
    setIsOpenMap(false)
  }
  const mapmodal = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "#182424",
    },
    overlay: {
      zIndex: "9999",
    },
  }

  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  if (module.hideSection === "no") {
    return (
      <>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className="bloggrid bg-brown-500 bg-opacity-10 pb-60 mdscreen:pb-40"
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid"
          >
            <div className="mt-60 pt-60 mdscreen:pt-40">
              <div className="flex flex-wrap gap-y-[40px] -mx-10 lgscreen:mx-0">
                {allItineraries.nodes.length > 0 &&
                  allItineraries.nodes.map((item, i) => {
                    return (
                      <div
                        className="lg:w-6/12 w-full px-10 lgscreen:px-0"
                        key={i}
                      >
                        <motion.div
                          variants={animFade}
                          className="bg-white-100 p-25"
                        >
                          {item?.featuredImage && (
                            <motion.div
                              variants={animFade}
                              className="img relative"
                            >
                              <Link to={`${item.uri}`}>
                                <ImageOpt
                                  imgData={item.featuredImage.node.mediaItemUrl}
                                  width={370}
                                  height={200}
                                  imgAlt={item.featuredImage.node.altText}
                                  imgLoad="lazy"
                                />
                              </Link>
                            </motion.div>
                          )}
                          <div className="pt-30">
                            <motion.div
                              variants={animFade}
                              className="text-list md mb-10"
                            >
                              <ul className="flex flex-wrap gap-x-[20px]">
                                {item.itineraryContent.destinations?.length >
                                  0 &&
                                  item.itineraryContent.destinations.map(
                                    destination => {
                                      return (
                                        <li className="font-heading font-420 text-[#182424] tracking-[5%] uppercase text-12 mb-10 block">
                                          {destination.destinationName}
                                        </li>
                                      )
                                    }
                                  )}
                              </ul>
                            </motion.div>

                            {item?.title && (
                              <motion.div
                                variants={animFade}
                                className="title-green"
                              >
                                <span
                                  onClick={() => {
                                    setModalData(item)
                                    openModalMap()
                                  }}
                                >
                                  {" "}
                                  <h5>{item.title}</h5>
                                </span>
                              </motion.div>
                            )}
                            {item?.excerpt && (
                              <motion.div
                                variants={animFade}
                                className="content pt-10"
                              >
                                <p>{parse(item?.excerpt)}</p>
                              </motion.div>
                            )}

                            <motion.div
                              variants={animFade}
                              className="mt-20 flex gap-[20px] mdscreen:flex-col mdscreen:items-center"
                            >
                              <span
                                onClick={() => {
                                  setModalData(item)
                                  openModalMap()
                                }}
                                className="btn btn-green-border"
                              >
                                read more
                              </span>
                              {item.itineraryContent.downloadPdf && (
                                <a
                                  target={
                                    item.itineraryContent.downloadPdf.target
                                  }
                                  href={`${item.itineraryContent.downloadPdf.url}`}
                                  className="btn btn-link hover:cursor-pointer mdscreen:flex mdscreen:justify-center"
                                >
                                  <span class="flex flex-wrap gap-x-2 items-center">
                                    <img
                                      src="/images/download.svg"
                                      width="15"
                                      height="15"
                                      loading="lazy"
                                      alt="Map"
                                    />{" "}
                                    {item.itineraryContent.downloadPdf.title}
                                  </span>
                                </a>
                              )}
                            </motion.div>
                          </div>
                        </motion.div>
                      </div>
                    )
                  })}
              </div>
            </div>
          </motion.div>
        </motion.section>
        <Modal
          isOpen={modalIsOpenMap}
          style={mapmodal}
          onRequestClose={closeModalMap}
          contentLabel="Info Modal"
          ariaHideApp={false}
        >
          <div className="zigzag-modal-popup flex flex-col items-center justify-center bg-[#182424] h-full p-50 py-30 lgscreen:p-0">
            <div className="flex h-full w-full lgscreen:flex-col items-center relative bg-[#fff]">
              <button
                onClick={closeModalMap}
                className="absolute z-9 right-30 top-30 laptop:top-20 lgscreen:top-[10px] lgscreen:right-[10px]  flex items-center justify-center w-[40px] h-[40px]"
              >
                <img
                  src="/images/close-black.svg"
                  className="hidden lg:block"
                  width={16}
                  height={16}
                  alt="close-icon"
                />
                <img
                  src="/images/close.svg"
                  className="hidden lgscreen:block"
                  width={16}
                  height={16}
                  alt="close-icon"
                />
              </button>
              <motion.div
                variants={animFade}
                className="lg:w-[45%] w-full h-full lgscreen:h-[500px] mdscreen:h-[300px]"
              >
                <div className="relative h-full">
                  <Swiper
                    className="h-full"
                    spaceBetween={0}
                    loop={true}
                    slidesPerView={"11"}
                    centeredSlides={true}
                    speed={1500}
                    autoplay={false}
                    pagination={{
                      clickable: false,
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      641: {
                        slidesPerView: 1,
                      },
                      1024: {
                        slidesPerView: 1,
                      },
                    }}
                    modules={[Navigation]}
                  >
                    {modalData?.itineraryContent.sliderGallery?.length > 0 &&
                      modalData?.itineraryContent.sliderGallery?.map(
                        (item, i) => {
                          return (
                            <SwiperSlide key={i}>
                              <div className="img relative h-full">
                                <ImageOpt
                                  imgData={item.image.mediaItemUrl}
                                  width={650}
                                  height={760}
                                  imgAlt={item.image.altText}
                                  imgLoad="lazy"
                                  imgClass="w-full h-full object-cover"
                                />
                              </div>
                            </SwiperSlide>
                          )
                        }
                      )}
                    <div className="swiper-arrow arrow-big flex gap-x-5">
                      <button
                        className="absolute top-50per translate-y-minus_50 z-9 left-40 mdscreen:left-20 w-[45px] h-[45px] mdscreen:w-[35px] mdscreen:h-[35px] bg-white-100 bg-opacity-40  backdrop-blur-[5px] rounded-100 transition-all duration-300 hover:bg-opacity-60"
                        onClick={() =>
                          handlePrevClick(".zigzag-modal-popup .swiper")
                        }
                      >
                        <img
                          src="/images/swiper-arrow.svg"
                          className="absolute top-50per left-50per translate-y-minus_50 translate-x-minus_50"
                          width={10}
                          height={10}
                          loading="lazy"
                          alt="Arrow"
                        />
                      </button>
                      <button
                        className="absolute top-50per translate-y-minus_50 z-9 right-40 mdscreen:right-20 w-[45px] h-[45px] mdscreen:w-[35px] mdscreen:h-[35px] bg-white-100 bg-opacity-40  filter-[5px] rounded-100 transition-all duration-300 hover:bg-opacity-60"
                        onClick={() =>
                          handleNextClick(".zigzag-modal-popup .swiper")
                        }
                      >
                        <img
                          src="/images/swiper-arrow.svg"
                          className="absolute top-50per left-50per translate-y-minus_50 translate-x-minus_50 rotate-180"
                          width={10}
                          height={10}
                          loading="lazy"
                          alt="Arrow"
                        />
                      </button>
                    </div>
                  </Swiper>
                </div>
              </motion.div>
              <div className="lg:w-[55%] w-full lgscreen:pt-40 h-full lgscreen:h-[calc(100%-500px)] mdscreen:h-[calc(100%-300px)]">
                <div className="zigzag-slider-content px-100 laptop:px-80 lgscreen:px-30 flex pb-40 pt-100 laptop:pt-60 lgscreen:pt-0 flex-col justify-start h-full overflow-auto">
                  <motion.div
                    variants={animFade}
                    className="text-list md mb-10"
                  >
                    <ul className="flex flex-wrap gap-x-[20px]">
                      {modalData?.itineraryContent?.destinations?.length > 0 &&
                        modalData?.itineraryContent?.destinations.map(
                          destination => {
                            return (
                              <li className="font-heading font-420 text-[#182424] tracking-[5%] uppercase text-12 mb-10 block">
                                {destination.destinationName}
                              </li>
                            )
                          }
                        )}
                    </ul>
                  </motion.div>

                  {modalData?.title && (
                    <motion.div variants={animFade} className="title-green">
                      {" "}
                      <h5>{modalData.title}</h5>
                    </motion.div>
                  )}
                  {modalData?.itineraryContent.nights && (
                    <motion.div
                      variants={animFade}
                      className="text-14 italic font-primary text-[#182424] mt-[15px] mb-[4px]"
                    >
                      {" "}
                      <p>{modalData.itineraryContent.nights} Nights</p>
                    </motion.div>
                  )}
                  {modalData?.itineraryContent.description && (
                    <motion.div variants={animFade} className="content pt-10">
                      <p>{parse(modalData?.itineraryContent.description)}</p>
                    </motion.div>
                  )}
                  <motion.div
                    variants={animFade}
                    className="tabs-horizontal pt-30 pb-10 pl-0 lgscreen:pt-10 !flex !h-full max-h-[60px]"
                  >
                    <ul className="tabs w-full flex flex-wrap gap-y-5 gap-x-[20px]">
                      {modalData?.itineraryContent.tabs &&
                        modalData?.itineraryContent.tabs.map((item, i) => {
                          const res = item.tabTitle.replace(/ /g, "")
                          return (
                            <li
                              key={i}
                              onClick={() => {
                                setTabOption(res)
                              }}
                              className={`tab-link cursor-pointer text-green-100 max-h-[29.5px] text-13 font-600 tracking-[1.04px] uppercase opacity-[0.65]  ${
                                tabOption === res ? "tab-current" : ""
                              }`}
                              data-tab={res}
                              onKeyDown={() => {
                                setTabOption(res)
                              }}
                              aria-hidden="true"
                            >
                              {item.tabTitle}
                            </li>
                          )
                        })}
                    </ul>
                  </motion.div>

                  {modalData?.itineraryContent.tabs &&
                    modalData?.itineraryContent.tabs.map((item, i) => {
                      const res = item.tabTitle.replace(/ /g, "")
                      return (
                        <div
                          key={i}
                          id={res}
                          className={`tab-content ${
                            tabOption === res ? "tab-current" : "hidden"
                          }`}
                        >
                          <motion.div
                            variants={animFade}
                            className="content global-list pt-10"
                          >
                            {item?.tabContent && <>{parse(item.tabContent)}</>}
                          </motion.div>
                        </div>
                      )
                    })}
                  {modalData?.itineraryContent.price && (
                    <motion.div
                      variants={animFade}
                      className="mt-[15px] mb-[4px]"
                    >
                      {" "}
                      <p className="text-15 uppercase !font-[420] font-heading text-[#182424]">
                        From Price {modalData.itineraryContent.price} per person
                      </p>
                    </motion.div>
                  )}
                  <motion.div
                    variants={animFade}
                    className="mt-20 flex gap-[20px] mdscreen:flex-col mdscreen:items-center"
                  >
                    <Link
                      to={modalData?.itineraryContent.button?.url}
                      target={modalData?.itineraryContent.button?.target}
                      className="btn btn-green"
                    >
                      <span class="flex flex-wrap gap-x-2 items-center mdscreen:justify-center">
                        {modalData?.itineraryContent.button?.title}{" "}
                        <img
                          src="/images/white-mail.svg"
                          className="relative top-[-1px]"
                          width="14"
                          height="14"
                          loading="lazy"
                          alt="Map"
                        />
                      </span>
                    </Link>
                    {modalData?.itineraryContent.watchVideo && (
                      <a
                        target={modalData?.itineraryContent.watchVideo.target}
                        href={`${modalData?.itineraryContent.watchVideo.url}`}
                        className="btn btn-green-border hover:cursor-pointer"
                      >
                        {modalData?.itineraryContent.watchVideo.title}
                      </a>
                    )}
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
  return null
}

export default ItineraryListing
export const PageItineraryListingFragment = graphql`
  fragment PageItineraryListingFragment on WpPage_Pagecontent_PageContent_ItineraryListing {
    extraId
    extraClass
    hideSection
  }
`
